var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardCard',{attrs:{"title":_vm.title,"content-padding":"","no-scroll":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.$route.name === 'details')?_c('VueApexChart',{attrs:{"height":"270","type":"line","series":_vm.series,"options":_vm.options}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }